import React from 'react';

import { useTranslation } from 'i18n/hooks';
import { Button, Table } from 'revibe-ui';
import { SpacedContainer } from 'revibe-ui';

import { RightArrowIcon } from 'ui/icons/RightArrowIcon';
import { useRouter } from 'next/router';
import { COMPANY_ROUTES } from 'routes';

interface Props {
  alternative?: boolean;
}

export const SizesGuidance = ({ alternative = false }: Props) => {
  const { tu } = useTranslation('shop.sizes');
  const router = useRouter();
  const dataWoman = alternative
    ? [
        ['XXS', '32'],
        ['XS', '34'],
        ['S', '36-38'],
        ['M', '40-42'],
        ['L', '44-46'],
        ['XL', '48-50'],
        ['XXL', '52'],
      ]
    : [
        ['XXS', '32', '36', '4'],
        ['XS', '34', '38', '6'],
        ['S', '36', '40', '8'],
        ['M', '38', '42', '10'],
        ['L', '40', '44', '12'],
        ['XL', '42', '46', '14'],
        ['XXL', '44', '48', '16'],
        ['3XL', '46', '50', '18'],
      ];
  const dataMan = alternative
    ? [
        ['XXS', '42', '32'],
        ['XS', '44', '34'],
        ['S', '46', '36'],
        ['M', '48', '38'],
        ['L', '50', '40'],
        ['XL', '52', '42'],
        ['XXL', '54', '44'],
        ['3XL', '56', '46'],
      ]
    : [
        ['XXS', '42', '32'],
        ['XS', '44', '34'],
        ['S', '46', '36'],
        ['M', '48', '38'],
        ['L', '50', '40'],
        ['XL', '52', '42'],
        ['XXL', '54', '44'],
        ['3XL', '56', '46'],
      ];

  return (
    <SpacedContainer className="p-4">
      <h1 className="text-3xl text-black">{tu('size-guide', 'shop')}</h1>
      <div className="flex grid-cols-2 flex-col gap-4 md:grid">
        <SpacedContainer>
          <h2>{tu('female', 'common')}</h2>
          <Table
            data={dataWoman}
            columns={
              alternative
                ? [tu('size'), `FR & ${tu('europe', 'common')}`]
                : [tu('size'), `FR & ${tu('europe', 'common')}`, 'IT', 'UK']
            }
          />
        </SpacedContainer>
        <SpacedContainer>
          <h2>{tu('male', 'common')}</h2>
          <Table
            data={dataMan}
            columns={[tu('size'), tu('europe', 'common'), 'UK']}
          />
        </SpacedContainer>
      </div>
      <p>{tu('cant-find-answer', 'common')}</p>
      <Button
        onClick={() => {
          router.push(COMPANY_ROUTES.CONTACT_US);
        }}
      >
        <RightArrowIcon className="h-6 w-6 stroke-white" />{' '}
        {tu('write-us', 'common')}
      </Button>
    </SpacedContainer>
  );
};
